import type { DashboardStatusBreakdownDto, DashboardDriverWorkloadEntryDto } from "@carry/contract";

/** 円グラフ 1 区分. recharts Pie の dataKey="value" / nameKey="name" に対応. */
export interface PieDatum {
  name: string;
  value: number;
}

/** 折れ線グラフ 1 点. 末尾は「今日」ラベルに置換済み. */
export interface TrendDatum {
  date: string;
  label: string;
  total: number;
  completed: number;
}

type TrendEntry = { date: string; total: number; completed: number };

/**
 * 円グラフ用: 当日のステータス別内訳を 4 区分に集約する.
 * draft+confirmed=未配送 / assigned=配送中 / completed=完了 / cancelled=キャンセル.
 * value=0 の区分は除外する.
 */
export function buildPieData(breakdown: DashboardStatusBreakdownDto): PieDatum[] {
  const data: PieDatum[] = [
    { name: "未配送", value: breakdown.draft + breakdown.confirmed },
    { name: "配送中", value: breakdown.assigned },
    { name: "完了", value: breakdown.completed },
    { name: "キャンセル", value: breakdown.cancelled },
  ];
  return data.filter((d) => d.value > 0);
}

/** 棒グラフ用: ドライバー別配送件数を total 降順に並べる (元配列は破壊しない). */
export function sortDriverBars(
  byDriver: DashboardDriverWorkloadEntryDto[],
): DashboardDriverWorkloadEntryDto[] {
  return [...byDriver].sort((a, b) => b.total - a.total);
}

/**
 * 折れ線グラフ用: 推移データの末尾 7 件を返し、最後の点のラベルを「今日」にする.
 * 7 件未満ならそのまま末尾を「今日」にする. それ以外のラベルは MM-DD (date.slice(5)).
 */
export function sliceLast7(trend: TrendEntry[]): TrendDatum[] {
  const last7 = trend.slice(-7);
  return last7.map((entry, i) => ({
    date: entry.date,
    label: i === last7.length - 1 ? "今日" : entry.date.slice(5),
    total: entry.total,
    completed: entry.completed,
  }));
}
